// Grid 조회 버튼
const SearchButtonBox = ({ title = '조회', onClick }) => {
    return (
        <button type='button' className='btn search' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export default SearchButtonBox;
